'use strict';

angular.module('atex.dam').controller('DamFacetController', ['$scope', '$sce', '$q', 'DamSearchService', 'DamService',
function($scope, $sce, $q, DamSearchService, DamService) {

  DamSearchService.getFacetRepeatStep().then(function (value) {
    $scope.facetRepeatStep = value;
  });
  $scope.loadingFacet = false;

  $scope.facetByItem = function (fieldName, item, action) {
    DamSearchService.facetByItem(fieldName, item, action);
  };

  $scope.to_trusted = function (html_code) {
    return $sce.trustAsHtml(html_code);
  };

  $scope.$on("dam:loading-facet:start", function () {
    $scope.loadingFacet = true;
  });

  $scope.$on("dam:loading-facet:stop", function () {
    $scope.loadingFacet = false;
  });


  $scope.$on("dam:loading-facet:execute", function () {
    loadFacets(DamSearchService.getFacetSettings());
  });

  var loadFacets = function (settings) {
    return DamService.getFacetsValues(settings.query, settings.filter).then(function (facetResults) {
      DamSearchService.initFaceting(facetResults.data);
      var promise = $q.defer().resolve();
      if (settings.fullText) {
        promise = DamService.getFullTextFacets(settings.query);
      } else if (settings.advancedFacets) {
        promise = DamService.getAdvancedFacets(settings.query, settings.childrenQueryString);
      }
      return promise.then(function (facetResults) {
        if (settings.extraInfo && !DamSearchService.isStillLastQuery(settings.extraInfo.queryTs)) {
          return $q.reject();
        }
        DamSearchService.addFaceting(facetResults.data, true);
        $scope.facets = DamSearchService.getFacets();
        $scope.filterQuery = DamSearchService.getFacetFilterQuery();
      });
    }).catch(function (error) {
      console.log('ERROR: Performing facet query:', error);
    }).finally(function () {
      $scope.$broadcast("dam:loading-facet:stop");
    });
  };

  // Initially the settings are empty - these will be updated via an external event from the search-service
  var settings = DamSearchService.getFacetSettings();
  if (settings) {
    loadFacets(settings);
  }

}]);
